import { createShapeNormalizer } from '@change-corgi/fcm/normalizers';

import { defineFcm } from '../shared/factory';

export const FCM_PSF_PROMOTE_OR_SHARE_FACEBOOK_POST_SHEET = defineFcm('psf_promote_or_share_facebook_post_sheet')
	.asJson(
		createShapeNormalizer({
			type: 'object',
			shape: {
				enabled: { type: 'boolean' },
				experimentName: { type: 'string' },
			},
		}),
	)
	.withDefault(undefined)
	.toConfig({
		owner: 'squad-platypus',
		scope: 'corgi-front-end',
		context: 'psf promote-or-share share slide-up',
		description:
			'Kill-switch and experiment binding for the Facebook post sheet on the promote_or_share share slide-up. Four arms: control, fake_control, variant_1, variant_2.',
		template: {
			enabled: false,
			experimentName: 'psf_promote_or_share_facebook_post_sheet_experiment',
		},
	});
